<template id="table-resultados">
    <div>
        <simple-table
            :rows="rows"
            :columns="columns"
            :perPage="[10, 25, 50, 100]"
            :classes="tableClasses"
        >
            <tbody slot="body" slot-scope="{ data }">
                <tr :key="item.id" v-for="item in data">
                    <template v-if="tab == 'horarios'">
                        <td v-if="rol == 'root'" class="px-1">
                            <div class="tblPrincipal">{{ item.nombre_empresa }}</div>
                        </td>

                        <td v-if="rol == 'admin'">
                            <div class="tblPrincipal">{{ item.nombre_empresa }}</div>
                        </td>
                        <td v-if="rol == 'admin'">
                            <div class="tblPrincipal">{{ item.nombre_sucursal }}</div>
                        </td>

                        <td v-if="rol == 'admin-empresa'">
                            <div class="tblPrincipal">{{ item.nombre_sucursal }}</div>
                        </td>

                        <td v-if="rol == 'admin-sucursal'">
                            <div class="tblPrincipal">{{ item.nombre }}</div>
                        </td>
                        <td v-if="rol != 'admin-sucursal'">
                            <div class="tblPrincipal">{{ item.nombre }}</div>
                        </td>

                        <td>
                            <div class="tblPrincipal">{{ item.descripcion }}</div>
                        </td>

                        <td v-if="rol == 'admin-depto'">
                            <div class="tblPrincipal">{{ item.minutos_tolerancia }}</div>
                        </td>
                        <td v-if="rol != 'admin-depto' && rol != 'empleado'">
                            <div class="tblOpciones">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            class="botonHover"
                                            icon
                                            fab
                                            dark
                                            small
                                            @click="abrirModal('update', item)"
                                        >
                                            <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="permisos.delete">
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            class="botonHover"
                                            icon
                                            fab
                                            dark
                                            small
                                            @click="eliminar(item.id, item.nombre)"
                                        >
                                            <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </template>
                </tr>
            </tbody>
        </simple-table>


        <template>
            <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <ValidationObserver ref="form" v-slot="{ invalid }">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                <img :src="modalImagen" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga" >
                                    <div id="loading">
                                        <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                        ></v-progress-circular>
                                    </div>
                                </div>

                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col xs="12" sm="8" md="8" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Nombre" rules="required">
                                                <v-text-field
                                                    autofocus
                                                    id="primero"
                                                    outlined
                                                    label="Nombre"
                                                    v-model="horario.nombre"
                                                    :error-messages="errors"
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col xs="12" sm="4" md="4" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Minutos tolerancia" rules="required|numeros_positivos">
                                                <v-text-field
                                                    outlined
                                                    label="Minutos tolerancia"
                                                    v-model="horario.minutos_tolerancia"
                                                    v-mask="'####'"
                                                    :error-messages="errors"
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col xs="12" sm="12" md="12" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Descripción" rules="required">
                                                <v-text-field
                                                    outlined
                                                    label="Descripción"
                                                    v-model="horario.descripcion"
                                                    :error-messages="errors"
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <template>
                                            <v-col xs="12" sm="6" md="6" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Tipo jornada" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="jornadas"
                                                        item-text="descripcion"
                                                        item-value="id"
                                                        label="Tipo jornada"
                                                        persistent-hint
                                                        v-model="horario.jornada_id"
                                                        :error-messages="errors"
                                                        no-data-text="Datos no disponibles"
                                                    />
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'root'">
                                            <v-col xs="12" sm="6" md="6" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="clientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Cliente"
                                                        persistent-hint
                                                        v-model="cliente_value"
                                                        :error-messages="errors"
                                                        no-data-text="Datos no disponibles"
                                                    />
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'root' || rol == 'admin'">
                                            <v-col xs="12" sm="6" md="6" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="empresas"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Empresa"
                                                        persistent-hint
                                                        v-model="empresa_value"
                                                        :error-messages="errors"
                                                        no-data-text="Datos no disponibles"
                                                    />
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                            <v-col xs="12" sm="6" md="6" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Sucursal" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="sucursales"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Sucursal"
                                                        persistent-hint
                                                        v-model="horario.sucursal_id"
                                                        :error-messages="errors"
                                                        required
                                                        no-data-text="Datos no disponibles"
                                                    />
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <v-col xs="12" sm="12" md="12" class="py-0 pl-3">
                                            <h4 class="selDias">Seleccionar días</h4>
                                        </v-col>
                                        
                                        <div class="centrar">
                                            <v-checkbox
                                                v-for="(d, index) in semanaHorarios"
                                                :key="index"
                                                hide-details
                                                class="shrink mr-4 mt-0 dias"
                                                v-model="dias_seleccionados"
                                                :label="d.dia"
                                                :value="d.dia"
                                                :disabled="d.desabilitar"
                                            ></v-checkbox>
                                        </div>
                                    </v-row>
                                    <v-row>
                                        <v-col v-if="!navegador" xs="12" sm="5" md="5" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Hora entrada"
                                                v-model="hora_entrada"
                                                id="hora_entrada"
                                                type="time"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-else xs="12" sm="5" md="5" class="py-0">
                                            <v-menu
                                                ref="menu"
                                                v-model="menu1"
                                                :close-on-content-click="false"
                                                :nudge-right="10"
                                                :return-value.sync="time"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="hora_entrada"
                                                        label="Hora entrada"
                                                        readonly
                                                        outlined
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="menu1"
                                                    v-model="hora_entrada"
                                                    full-widthformat="24hr"
                                                    scrollable
                                                    ampm-in-title
                                                    @click:minute="$refs.menu.save(hora_entrada)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col v-if="!navegador" xs="12" sm="5" md="5" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Hora salida"
                                                v-model="hora_salida"
                                                id="hora_salida"
                                                type="time"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-else xs="12" sm="5" md="5" class="py-0">
                                            <v-menu
                                                ref="menuFin"
                                                v-model="menu2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="time"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="hora_salida"
                                                        label="Hora salida"
                                                        readonly
                                                        outlined
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="menu2"
                                                    v-model="hora_salida"
                                                    full-widthformat="24hr"
                                                    scrollable
                                                    ampm-in-title
                                                    @click:minute="$refs.menuFin.save(hora_salida)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col xs="12" sm="2" md="2" class="py-0">
                                            <v-btn
                                                color="#1E2245"
                                                elevation="0"
                                                class="mt-2"
                                                dark
                                                fab
                                                @click="agregarHorario()"
                                                small
                                            >
                                                <v-icon dark>add</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="3" md="4" class="py-0">
                                            <v-input disabled class="pl-2">Día</v-input>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="3" md="3" class="py-0">
                                            <v-input disabled class="pl-2">Entrada</v-input>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="3" md="3" class="py-0">
                                            <v-input disabled class="pl-2">Salida</v-input>
                                        </v-col>
                                    </v-row>
                                    <v-row v-for="(i, index) in horario.detallesHorarios" :key="index">
                                        <template >
                                            <v-col col="12" xs="12" sm="3" md="4" class="detalle">
                                                <v-text-field
                                                    id="file_input_file"
                                                    label="Dia"
                                                    disabled
                                                    class
                                                    type="text"
                                                    :value="i.dia"
                                                    outlined
                                                    single-line
                                                    dense
                                                ></v-text-field>
                                            </v-col>

                                            <v-col xs="12" sm="3" md="3" class="detalle">
                                                <v-text-field
                                                    label="entrada"
                                                    type="text"
                                                    :value="i.hora_entrada"
                                                    disabled
                                                    outlined
                                                    single-line
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col xs="12" sm="3" md="3" class="detalle">
                                                <v-text-field
                                                    label="salida"
                                                    type="text"
                                                    :value="i.hora_salida"
                                                    disabled
                                                    outlined
                                                    single-line
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col xs="12" sm="2" md="2" class="detalle">
                                                <v-btn
                                                    :key="index"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminaHorario(index, i.id)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()" 
                                    :disabled="loading_guardar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()" 
                                    :disabled="invalid" 
                                    :loading="loading_guardar"
                                    v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions>

                            <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                <v-alert
                                    dense
                                    outlined
                                    type="error"
                                >
                                    El usuario no tiene permiso para editar el registro.
                                </v-alert>
                            </div>
                        </ValidationObserver>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>


    </div>
</template>

<script>
import Notify from "@/plugins/notify";
import Datatable from "@/components/simpletable/Datatable.vue";
import horariosApi from "../api/horarios";
import clientesApi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import apiTipoJornada from "../api/nominas/tipoJornada";

export default {
    components: {
        'simple-table': Datatable,
    },
    props: {
        tab: String,
        rol: String,
        columns: Array,
        rows: Array,
    },
    data() {
        return {
            months   : ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            tableClasses: {
                "t-head" : {
                    "tamanio-head":true
                }
            },
            datosLogin      : null,
            
            horario: {
                id                  : 0,
                nombre              : "",
                descripcion         : "",
                minutos_tolerancia  : "",
                cliente_id          : "",
                empresa_id          : "",
                sucursal_id         : "",
                detallesHorarios    : [],
                detalles_eliminados : [],
                jornada_id          : null,
            },
            dias_seleccionados: [],
            semanaHorarios: [
                { dia: "Lunes", desabilitar: false },
                { dia: "Martes", desabilitar: false },
                { dia: "Miércoles", desabilitar: false },
                { dia: "Jueves", desabilitar: false },
                { dia: "Viernes", desabilitar: false },
                { dia: "Sábado", desabilitar: false },
                { dia: "Domingo", desabilitar: false },
            ],
            semana: [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ],
            semanaOriginal: [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ],
            dialog          : false,
            dia             : "",
            nombre          :"",
            hora_entrada    : "",
            hora_salida     : "",
            titulo_modal    : "",
            finaliza_carga  : false,
            action          : "",
            clientes        : [],
            empresas        : [],
            sucursales      : [],
            cliente_value   : null,
            empresa_value   : null,
            sucursal_value  : null,
            dias_eliminados : [],
            jornadas        : [],
            loading_guardar : false,
            modalImagen     : '',
            jornada_nocturna : false,

            navegador       :false,

            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        }
    },
    watch: {
        cliente_value: function(val) {
            this.cambiaCliente(val);
        },
        empresa_value: function(val) {
            this.cambiaEmpresa(val);
        },
        "horario.jornada_id": function(value){
            for(let jornada of this.jornadas){
                if(jornada.id == value){
                    if(jornada.clave === "02"){
                        this.jornada_nocturna = true;
                    }else{
                        this.jornada_nocturna = false;
                    }
                }
            }
        }
    },
    methods: {
        eliminar(id, horario) {
            Notify.Alert(
                "¿Estás seguro de eliminar este horario?",
                "Esta acción <b>puede afectar</b> algunas funcionalidades del sistema.",
                "Eliminar",
                () => {
                    this.isLoading = true;
                    horariosApi.deleteHorario(id).then((response) => {
                        this.$emit('updateSearch', 'horarios');
                        this.respuesta_ok("Operación exitosa", "El horario ha sido eliminado satisfactoriamente.");
                    })
                    .catch((err) => {
                        this.isLoading = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                },
                null,
                true,
                true
            );
        },
        async abrirModal(accion, item = null) {
            this.accion = accion;
            this.finaliza_carga = false

            this.titulo_modal = "Actualizar horario";
            this.modalImagen = "/static/icon/horarioUpdate.svg"

            horariosApi.getHorario(item.id).then((response) => {
                this.horario.id = response.id;
                this.horario.nombre = response.nombre;
                this.horario.descripcion = response.descripcion;
                this.horario.minutos_tolerancia = response.minutos_tolerancia;
                this.cliente_value = response.cliente_id;
                this.empresa_value = response.empresa_id;
                this.horario.sucursal_id = response.sucursal_id;
                this.horario.detallesHorarios = response.detalles_horarios;
                this.horario.jornada_id = response.jornada_id;
                if (response.cliente != undefined) {
                    this.horario.cliente_id = response.cliente_id;
                }
                if (response.empresa != undefined) {
                    this.horario.empresa_id = response.empresa_id;
                }
                if (response.sucursal != undefined) {
                    this.horario.sucursal_id = response.sucursal_id;
                }

                let ordenaDetalle_horario = [];
                for (var i = 0; i < this.semanaOriginal.length; i++) {
                    for (var j = 0; j < this.horario.detallesHorarios.length; j++) {
                        if (this.semanaOriginal[i] === this.horario.detallesHorarios[j].dia) {
                            ordenaDetalle_horario.push(this.horario.detallesHorarios[j]);
                        }
                    }
                }
                this.horario.detallesHorarios = ordenaDetalle_horario;
                this.horario.detallesHorarios.forEach((element) => {
                    this.semanaHorarios.forEach((el) => {
                        if (element.dia == el.dia) {
                            el.desabilitar = true;
                        }
                    });
                });
                this.horario.detallesHorarios.forEach((element) => {
                    if (element.dia === "Lunes") {
                        let index = this.semana.indexOf(element.dia);
                        this.semana.splice(index, 1);
                    }
                    if (element.dia === "Martes") {
                        let index = this.semana.indexOf(element.dia);
                        this.semana.splice(index, 1);
                    }
                    if (element.dia === "Miércoles") {
                        let index = this.semana.indexOf(element.dia);
                        this.semana.splice(index, 1);
                    }
                    if (element.dia === "Jueves") {
                        let index = this.semana.indexOf(element.dia);
                        this.semana.splice(index, 1);
                    }
                    if (element.dia === "Viernes") {
                        let index = this.semana.indexOf(element.dia);
                        this.semana.splice(index, 1);
                    }
                    if (element.dia === "Sábado") {
                        let index = this.semana.indexOf(element.dia);
                        this.semana.splice(index, 1);
                    }
                    if (element.dia === "Domingo") {
                        let index = this.semana.indexOf(element.dia);
                        this.semana.splice(index, 1);
                    }
                });
                this.finaliza_carga = true;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar los horarios.");
            });
            
            if (this.rol == "root") {
                await this.getClientes();
            }
            if (this.rol == "admin") {
                await this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                this.cliente_value = this.datosLogin.cliente_id;
            }
            if (this.rol == "admin-empresa") {
                await this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
            if (this.rol == "admin-sucursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.horario.sucursal_id = this.datosLogin.sucursal_id;
            }
            setTimeout(() => {
                document.getElementById("btnModal").click();
            }, 100);
        },

        agregarHorario() {
            if (
                this.dias_seleccionados != "" &&
                this.hora_entrada != "" &&
                this.hora_salida != ""
            ) {
                var hr_entrada = parseInt(this.hora_entrada.substring(0, 2));
                var min_entrada = parseInt(this.hora_entrada.substring(2, 4));
                var hr_salida = parseInt(this.hora_salida.substring(0, 2));
                var min_salida = parseInt(this.hora_salida.substring(2, 4));
                if (
                    hr_entrada > 23 ||
                    min_entrada > 60 ||
                    hr_salida > 23 ||
                    min_salida > 60
                ) {
                    Notify.Warning("Hora incorrecta", "La hora registrada es incorrecta" );
                } else {
                    if (!this.jornada_nocturna && (this.hora_salida <= this.hora_entrada)) {
                        Notify.Warning("Hora incorrecta", "La hora de salida debe ser mayor a la hora de entrada. Formato de hora hh:mm, Ejemplos: 09:00 - 13:00" );
                    } else {
                        if (this.hora_entrada.length < 4 || this.hora_salida.length < 4) {
                            Notify.Warning("Formato de hora incorrecta", "Formato de hora hh:mm, Ejemplos: 09:00 - 13:00" );
                        } else {
                            this.hora_entrada =
                                this.hora_entrada.substring(0, 2) +
                                ":" +
                                this.hora_entrada.substring(3, 5) +
                                ":00";

                            this.hora_salida =
                                this.hora_salida.substring(0, 2) +
                                ":" +
                                this.hora_salida.substring(3, 5) +
                                ":00";
                            this.dias_seleccionados.forEach((element) => {
                                let detalle_horario = {
                                    id: 0,
                                    dia: element,
                                    hora_entrada: this.hora_entrada,
                                    hora_salida: this.hora_salida,
                                }; //Se agrega el id:0
                                this.horario.detallesHorarios.push(detalle_horario);
                                let ordenaDetalle_horario = [];
                                for (var i = 0; i < this.semanaOriginal.length; i++) {
                                    for (
                                        var j = 0;
                                        j < this.horario.detallesHorarios.length;
                                        j++
                                    ) {
                                        if (this.semanaOriginal[i] === this.horario.detallesHorarios[j].dia) {
                                            ordenaDetalle_horario.push(
                                                this.horario.detallesHorarios[j]
                                            );
                                        }
                                    }
                                }
                                this.horario.detallesHorarios = ordenaDetalle_horario;
                            });
                            this.horario.detallesHorarios.forEach((element) => {
                                this.semanaHorarios.forEach((el) => {
                                    if (element.dia == el.dia) {
                                        el.desabilitar = true;
                                    }
                                });
                            });
                            this.dias_seleccionados = [];
                            this.hora_entrada = "";
                            this.hora_salida = "";
                        }
                    }
                }
            }
            else{
                if(this.dias_seleccionados.length == 0){
                    Notify.Warning("Seleccionar días", "Seleccionar al menos un día." );
                }
                else if( this.hora_entrada == "" || this.hora_salida == ""){
                    Notify.Warning("Formato hora", "Ingresar un horario correcto. Ejemplo: 12:30." );
                }                
            }
        },

        eliminaHorario(index, id) {
            if (id != 0) {
                let id_dia = { eliminado_id: id };
                this.horario.detalles_eliminados.push(id_dia);
            }
            let dia = this.horario.detallesHorarios[index].dia;
            this.semanaHorarios.forEach((el) => {
                if (dia == el.dia) {
                    el.desabilitar = false;
                }
            });
            this.horario.detallesHorarios.splice(index, 1);
        },

        guardar() {
            this.horario.cliente_id = this.cliente_value;
            this.horario.empresa_id = this.empresa_value;
            this.$refs.form.validate().then(success => {
                this.loading_guardar = true;
                if (!success) {
                    this.loading_guardar = false;
                    return;
                }
                    
                this.horario.minutos_tolerancia = parseInt(
                    this.horario.minutos_tolerancia,
                    10
                );

                if(this.horario.detallesHorarios.length == 0){
                    Notify.ErrorToast("Es requerido agregar al menos un día con horario");
                    this.loading_guardar = false;
                }else{
                    this.horario.detalles_horario = this.horario.detallesHorarios;
                    horariosApi.updateHorario(this.horario).then((response) => {
                        this.isLoading = true;
                        this.$emit('updateSearch', 'horarios');
                        Notify.Success("Operación exitosa", "El horario se actualizó satisfactoriamente.");
                        this.cerrarModal();
                    })
                    .catch((err) => {
                        this.isLoading = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            });
            this.semana = [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ];
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValue();
        },
        resetValue() {
            this.horario.id = 0;
            this.horario.nombre = "";
            this.horario.descripcion = "";
            this.horario.minutos_tolerancia = "";
            this.horario.cliente_id = "";
            this.horario.empresa_id = "";
            this.horario.sucursal_id = "";
            this.horario.detallesHorarios = [];
            this.horario.detalles_eliminados = [];
            this.horario.jornada_id = null;
            this.dia = "";
            this.hora_entrada = "";
            this.hora_salida = "";
            this.semana = [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ];
            this.semanaHorarios = [
                { dia: "Lunes", desabilitar: false },
                { dia: "Martes", desabilitar: false },
                { dia: "Miércoles", desabilitar: false },
                { dia: "Jueves", desabilitar: false },
                { dia: "Viernes", desabilitar: false },
                { dia: "Sábado", desabilitar: false },
                { dia: "Domingo", desabilitar: false },
            ];
            
            this.$nextTick(() => {
                if(this.$refs.form != undefined || this.$refs.form != null){
                    this.$refs.form.reset();
                } 

                if(this.rol == 'root'){
                    this.cliente_value      = null;
                    this.empresa_value      = null;
                    this.sucursal_value     = null;
                    this.empresas           = [];
                    this.sucursales         = [];
                }

                if(this.rol == 'admin'){
                    this.empresa_value      = null;
                    this.sucursal_value     = null;
                    this.sucursales         = [];
                } 

                if(this.rol == 'admin-empresa'){
                    this.sucursal_value     = null;
                }

                this.dias_seleccionados = [];
                this.loading_guardar = false;
            });
        },
        async getClientes(clientes = null) {
            let param = { activo: true, paginate: false };
            await clientesApi.getClientes(param).then((response) => {
                this.clientes = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        cambiaCliente(cliente, accion = null) {
            if(cliente == null){
                return;
            }
            let param = { activo: true, paginate: false, cliente_id: cliente };
            empresaApi.getEmpresas(param).then((response) => {
                this.empresas = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaEmpresa(empresa, accion = null) {
            if(empresa == null){
                return;
            }
            let parametros = { activo: true, paginate: false, empresa_id: empresa };
            sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        getTipoJornada() {
            let parametros = { activo: true, paginate: false, order: "asc" };
            apiTipoJornada.find(parametros).then((response) => {
                this.jornadas = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las jornadas.");
            });
        },

        
        detectarNavegador(){
            let sBrowser, sUsrAg = navigator.userAgent;
            if(sUsrAg.indexOf("Chrome") > -1) {
                sBrowser = "Google Chrome";
                this.navegador = false;
            } else if (sUsrAg.indexOf("Safari") > -1) {
                sBrowser = "Apple Safari";
                this.navegador = true;
            } else if (sUsrAg.indexOf("Opera") > -1) {
                sBrowser = "Opera";
                this.navegador = false;
            } else if (sUsrAg.indexOf("Firefox") > -1) {
                sBrowser = "Mozilla Firefox";
                this.navegador = false;
            } else if (sUsrAg.indexOf("MSIE") > -1) {
                sBrowser = "Microsoft Internet Explorer";
                this.navegador = false;
            }
            else {
                sBrowser = "Microsoft Internet Explorer";
                this.navegador = false;
            }
        },
        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("horarios.store")
            this.permisos.update = permisosStorage.includes("horarios.update")
            this.permisos.delete = permisosStorage.includes("horarios.delete")
        },
    },

    created() {
        this.datosLogin = this.$session.get("usuario");
        this.permisosVista();
        this.detectarNavegador();
        this.getTipoJornada();
    },
}
</script>

<style>
   .centrar {
        height: 90px;
        width: 500px;
        margin: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 25px;
    }
    .dias {
        height: 35px;
    }
    .selDias {
        margin-top: -10px;
        font-family: "Montserrat";
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.2px;
        color: #A0A4A8;
        margin-bottom: 15px;
    }

    .detalle {
        margin-top: -30px !important;
    }
</style>